export const PET = [
  {
    pet: require("@/assets/images/pet/-1.png"),
    id: -1,
  },
  {
    pet: require("@/assets/images/pet/0.png"),
    id: 0,
  },
  {
    pet: require("@/assets/images/pet/1.png"),
    id: 1,
  },
  {
    pet: require("@/assets/images/pet/2.png"),
    id: 2,
  },
  {
    pet: require("@/assets/images/pet/3.png"),
    id: 3,
  },
  {
    pet: require("@/assets/images/pet/4.png"),
    id: 4,
  },
  {
    pet: require("@/assets/images/pet/5.png"),
    id: 5,
  },
  {
    pet: require("@/assets/images/pet/6.png"),
    id: 6,
  },
  {
    pet: require("@/assets/images/pet/7.png"),
    id: 7,
  },
];
